import { Box, CircularProgress, Grid } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { ITextField } from 'components';
import { useTranslation } from 'react-i18next';
import { useAPI } from 'stores';
import { InputFieldProps } from 'types';
import { useFormRules } from 'utils';

const InlineCaptchaField = ({ control }: InputFieldProps) => {
	const { t } = useTranslation();
	const { formRules } = useFormRules();
	const { getValidationCode } = useAPI();

	const { data, refetch, isRefetching } = useQuery(
		['getValidationCode'],
		async () => {
			return await getValidationCode();
		},
		{ refetchOnWindowFocus: false }
	);

	return (
		<Grid container justifyContent="space-between">
			<Grid item xs={6.5}>
				<ITextField
					control={control}
					name="captcha"
					type="text"
					label={t('form.captcha')}
					rules={formRules.captcha}
				/>
			</Grid>
			<Grid
				container
				item
				xs={5}
				m={0.25}
				alignItems="center"
				justifyContent="center"
				sx={{
					backgroundColor: 'white',
					borderRadius: '8px',
					maxHeight: '56px',
					overflow: 'hidden',
				}}
			>
				{data && !isRefetching ? (
					<Box
						component="img"
						p={0.5}
						alt="validationCode"
						src={`${process.env.REACT_APP_DOMAIN_NAME}${process.env.REACT_APP_API_GET_IMAGE}?name=${data.data}`}
						onClick={() => {
							refetch();
						}}
					/>
				) : (
					<CircularProgress size={30} />
				)}
			</Grid>
		</Grid>
	);
};

export default InlineCaptchaField;
